/** The unread count as the chat badges show it (top bar, sidebar, minimised window): empty for none, capped at 99+. */
export function unreadBadge(unread: number | null | undefined): string {
  if (!unread || unread < 1) return '';
  return unread > 99 ? '99+' : String(unread);
}
